module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_8004.4f2095d2.png";